import  gql  from 'graphql-tag'

export const identificationDocumentTypes = gql`query identificationDocumentTypes($isActive: Boolean){ 
    identificationDocumentTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
